<template>
	<div>
		<el-card class="box-card">
			<el-col :span="2" style="margin-left: 10px;margin-bottom: 20px;">
				<el-button :loading="this.$store.state.ajaxLoading" type="primary" icon="el-icon-check" @click="read">标记已读</el-button>
			</el-col>
			<el-col :span="4" style="margin-left: 10px;margin-bottom: 20px;">
				<el-form label-width="80px">
					<el-form-item label="状态:">
						<el-col :span="24" style="margin-left: 5px;">
							<el-select v-model="listQuery.search.state" placeholder="请选择" @change="stateChange">
								<el-option label="全部" value=""></el-option>
								<el-option label="已读" value="1"></el-option>
								<el-option label="未读" value="0"></el-option>
							</el-select>
						</el-col>
					</el-form-item>
				</el-form>
			</el-col>
		</el-card>
		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small"
				@selection-change="changeFun">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="create_time" label="日期">
					<template slot-scope="{row}">
						<span>{{ row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="type_init" label="消息类型"> </el-table-column>
				<el-table-column prop="msg" label="内容"> </el-table-column>
				<el-table-column prop="state_init" label="状态">
					<template slot-scope="{row}">
						<el-tag :type="row.state==1 ? 'success':'danger'">
							{{ row.state_init}}
						</el-tag>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
		</div>
	</div>
</template>

<script>
	import {
		msgList,
		msgRead
	} from '@/api/jd_task'
	import request from '@/tool/request'
	import {
		parseTime
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	export default {
		components: {
			Pagination,
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				data_list: [], // 表格数据
				loading: true,
				checkbox_data: ''
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			this.getList()
		},
		methods: {
			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						state: '',
					},
				}
			},
			getList() { // 获取列表数据
				this.loading = true;
				msgList(Qs.stringify(this.listQuery)).then(response => {
					let r = response.result;
					this.data_list = r.items;
					this.total = r.total;
					this.loading = false;
					if(r.no_read_msg > 0){
						this.$store.commit('set_anx', true);
					}else{
						this.$store.commit('set_anx', false);
					}
				})
			},
			stateChange(){
				this.getList()
			},
			changeFun(val) { // 多选选中的时候，id值的变化
				let arr = [];
				for (let j = 0; j < val.length; j++) {
					let id = val[j]['id'];
					arr[j] = id;
				}
				this.checkbox_data = arr;
			},
			read() {
				this.$store.commit('setAjaxLoading', true);
				let post = {
					'ids': this.checkbox_data
				};
				msgRead(Qs.stringify(post)).then(response => {
					this.$message({
						showClose: true,
						message: '操作成功',
						type: 'success'
					});
					this.getList();
				})
			}
		}
	}
</script>
<style>
	.el-radio {
		margin-right: 0px;
	}
</style>
